import { render, staticRenderFns } from "./ShopVisits.vue?vue&type=template&id=2a8fbbf5&"
import script from "./ShopVisits.vue?vue&type=script&lang=js&"
export * from "./ShopVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports